import React from 'react'
import { Button } from '@/components/ui/button'
import { CheckIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

type EstateVisitDoneButtonProps = {
  onConfirm: (isVisitDone: boolean) => void
  enabled: boolean
  isVisitDone: boolean
}

export const EstateVisitDoneButton = ({
  onConfirm,
  enabled,
  isVisitDone,
}: EstateVisitDoneButtonProps) => {
  const { t } = useTranslation()

  return (
    <div className="tw-flex tw-justify-between tw-grow tw-content-center">
      {isVisitDone ? (
        <Button size="sm" onClick={() => onConfirm(false)} disabled={!enabled}>
          <CheckIcon className="tw-h-5 tw-w-5" />
          <span className="tw-ml-1">
            {t('EstateVisitDoneButton.button.undone')}
          </span>
        </Button>
      ) : (
        <Button
          size="sm"
          variant="outline"
          onClick={() => onConfirm(true)}
          disabled={!enabled}
        >
          {t('EstateVisitDoneButton.button.done')}
        </Button>
      )}
    </div>
  )
}
